import { render, staticRenderFns } from "./IngredientIcon.vue?vue&type=template&id=32c316d2&scoped=true"
import script from "./IngredientIcon.vue?vue&type=script&lang=js"
export * from "./IngredientIcon.vue?vue&type=script&lang=js"
import style0 from "./IngredientIcon.vue?vue&type=style&index=0&id=32c316d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c316d2",
  null
  
)

export default component.exports